export default __webpack_public_path__ + "static/media/NAUCSI_logo.95494582.png";